import { createContext } from 'react'

const PrinterContext = createContext(null)

export default PrinterContext
